import { render, staticRenderFns } from "./RelatorioLogTurno.vue?vue&type=template&id=2be869ac"
import script from "./RelatorioLogTurno.vue?vue&type=script&lang=js"
export * from "./RelatorioLogTurno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports